module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB5001-10b6099ad00d550768b8c02c0e349873.png";